import { render, staticRenderFns } from "./PlayerRefundList.vue?vue&type=template&id=890ede50&"
import script from "./PlayerRefundList.vue?vue&type=script&lang=ts&"
export * from "./PlayerRefundList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports